<template>
  <BootstrapModal
    class="Campaign mt-6"
    :remove-padding="true"
    
    v-on="$listeners"
  >
    <template #title>
      Bestelling toevoegen
    </template>
    <template #slot-options>
      <span></span>
    </template>

    <div>
      <div class="p-4 top-wrapper">
        <h2>Details</h2>
        <div class="d-flex discount-wrapper mt-3" :class="!loading && 'disable-ske'">
          <div class="metrics">
            <span v-for="fieldKey in campaignParams" :key="fieldKey">
              <div class="label">
                {{ reversedCampaign[fieldKey] }}
              </div>
              <span class="value" :class="{undefined: details[fieldKey] === null}">
                {{ details[fieldKey] !== null ? details[fieldKey] : "N/a" }}
              </span>
            </span>
          </div>
        </div>
      </div>

      <div class="p-4 metrics-wrapper">
        <h2 class="mt-3">Metrics</h2>
        <div class="d-flex discount-wrapper mt-3" :class="!loading && 'disable-ske'">
          <div class="metrics">
            <span v-for="fieldKey in metricsParams" :key="fieldKey">
              <div class="label">
                {{ reversedMetrics[fieldKey] }}
              </div>
              <span class="value" :class="{undefined: details[fieldKey] === null}">
                {{ details[fieldKey] !== null ? details[fieldKey] : "N/a" }}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"

import { fixCommaFloatingPointNumber } from "src/mixins/fixDecimalCommaNotation"

import { metrics, campaign } from "../../../utils/marketing-fields"

const reversedMetrics = {}
Object.keys(metrics).forEach(key => reversedMetrics[metrics[key]] = key)
const metricsValues = Object.values(metrics)

const reversedCampaign = {}
Object.keys(campaign).forEach(key => reversedCampaign[campaign[key]] = key)
const campaignValues = Object.values(campaign)

export default {
  components: {
    BootstrapModal,
  },
  props: {
    item: Object,
  },
  data() {
    return {
      details: {},
      loading: true,

      metrics,
      campaign,
      
      reversedCampaign,
      reversedMetrics,

      // metricsParams: Object.values(metrics),
      // campaignParams: Object.values(campaign),
    }
  },
  created() {
    this.details = this.item
  },
  computed: {
    metricsParams() {
      const details = this.details
      console.log("Details: ", details)
      return metricsValues.filter(key => details[key] !== undefined)
    },
    campaignParams() {
      const details = this.details
      return campaignValues.filter(key => details[key] !== undefined)
    },
  },
}

</script>

<style scoped>

.Campaign {
  flex-basis: 1100px;
}

.top-wrapper {
  padding-bottom: 8px !important;
}

.metrics-wrapper {
  padding-top: 6px !important;
  border-top: 1px solid rgba(230,230,230);
}

h2 {
  font-weight: 700;
  margin: 0;
  font-size: 18px;
}

.metrics {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 8px;
  gap: 12px;
}

.label {
  font-size: 13px;
  color: rgb(0,0,0);
  font-weight: 500;
}

.value {
  color: rgb(40,40,40);
  font-size: 11px;
}

.undefined {
  color: rgb(140,140,140);
}

</style>
